<template>
  <div class="cps-base-fields container">
    <h2 class="form-title">
      {{ $texts.baseFieldsTitle }}
    </h2>
    <label-field
      v-if="formData.field_NationalId && formData.field_NationalId.visible"
      fieldId="NationalId"
      :name="formData.field_NationalId.name"
      :description="formData.field_NationalId.description"
      :data="userData.nationalId"
      :tooltip="formData.field_NationalId.tooltip"
      :required="formData.field_NationalId.required"
      :enabled="formData.field_NationalId.enabled"
      v-model="userData.nationalId"
    ></label-field>
    <select-field
      v-if="formData.field_Title && formData.field_Title.visible"
      fieldId="Title"
      :name="formData.field_Title.name"
      :description="formData.field_Title.description"
      :tooltip="formData.field_Title.tooltip"
      :required="formData.field_Title.required"
      :enabled="formData.field_Title.enabled"
      :options="titleOptions"
      v-model="userData.title"
    ></select-field>

    <!-- Nom -->
    <input-field
      v-if="
        formData.field_LastName &&
          formData.field_LastName.visible &&
          (isCps || creationMode)
      "
      fieldId="LastName"
      :name="formData.field_LastName.name"
      :description="formData.field_LastName.description"
      :tooltip="formData.field_LastName.tooltip"
      :required="formData.field_LastName.required"
      :enabled="formData.field_LastName.enabled"
      :pattern="formData.field_LastName.regexp"
      v-model="userData.lastName"
    ></input-field>
    <input-fixed-field
      v-else-if="formData.field_LastName && formData.field_LastName.visible"
      fieldId="LastName"
      :name="formData.field_LastName.name"
      :description="formData.field_LastName.description"
      :tooltip="formData.field_LastName.tooltip"
      :required="formData.field_LastName.required"
      :enabled="formData.field_LastName.enabled"
      :pattern="formData.field_LastName.regexp"
      v-model="userData.lastName"
    ></input-fixed-field>

    <!-- Prénom -->
    <input-field
      v-if="
        formData.field_FirstName &&
          formData.field_FirstName.visible &&
          (isCps || creationMode)
      "
      fieldId="FirstName"
      :name="formData.field_FirstName.name"
      :description="formData.field_FirstName.description"
      :tooltip="formData.field_FirstName.tooltip"
      :required="formData.field_FirstName.required"
      :enabled="formData.field_FirstName.enabled"
      :pattern="formData.field_FirstName.regexp"
      v-model="userData.firstName"
    ></input-field>
    <input-fixed-field
      v-else-if="formData.field_FirstName && formData.field_FirstName.visible"
      fieldId="FirstName"
      :name="formData.field_FirstName.name"
      :description="formData.field_FirstName.description"
      :tooltip="formData.field_FirstName.tooltip"
      :required="formData.field_FirstName.required"
      :enabled="formData.field_FirstName.enabled"
      :pattern="formData.field_FirstName.regexp"
      v-model="userData.firstName"
    ></input-fixed-field>

    <!-- Mail -->
    <input-field
      v-if="
        formData.field_Mail &&
          formData.field_Mail.visible &&
          (isCps || creationMode)
      "
      fieldId="Mail"
      :name="formData.field_Mail.name"
      :description="formData.field_Mail.description"
      :tooltip="formData.field_Mail.tooltip"
      :required="formData.field_Mail.required"
      :enabled="formData.field_Mail.enabled"
      :pattern="formData.field_Mail.regexp"
      v-model="userData.email"
      type="email"
    ></input-field>
    <input-fixed-field
      v-else-if="formData.field_Mail && formData.field_Mail.visible"
      fieldId="Mail"
      :name="formData.field_Mail.name"
      :description="formData.field_Mail.description"
      :tooltip="formData.field_Mail.tooltip"
      :required="formData.field_Mail.required"
      :enabled="formData.field_Mail.enabled"
      :pattern="formData.field_Mail.regexp"
      v-model="userData.email"
    ></input-fixed-field>

    <!-- Mail de confirmation -->
    <input-field
      v-if="
        formData.field_ConfirmMail &&
          formData.field_ConfirmMail.visible &&
          (isCps || creationMode)
      "
      fieldId="ConfirmMail"
      :name="formData.field_ConfirmMail.name"
      :description="formData.field_ConfirmMail.description"
      :tooltip="formData.field_ConfirmMail.tooltip"
      :required="formData.field_ConfirmMail.required"
      :enabled="formData.field_ConfirmMail.enabled"
      :pattern="formData.field_ConfirmMail.regexp"
      v-model="userData.confirmEmail"
      type="email"
      :customRules="{ confirmed: 'Mail' }"
    ></input-field>

    <!-- Profession et spécialité -->
    <div v-if="isCps && hasProfessionSpecialite">
      <input-fixed-field
        v-if="
          formData.field_ProfessionSpecialite &&
            formData.field_ProfessionSpecialite.visible
        "
        fieldId="Profession"
        :name="'Profession'"
        :description="formData.field_ProfessionSpecialite.description"
        :tooltip="formData.field_ProfessionSpecialite.tooltip"
        :required="formData.field_ProfessionSpecialite.required"
        :enabled="formData.field_ProfessionSpecialite.enabled"
        :pattern="formData.field_ProfessionSpecialite.regexp"
        v-model="userData.labelProfession"
      ></input-fixed-field>
      <input-fixed-field
        v-if="
          formData.field_ProfessionSpecialite &&
            formData.field_ProfessionSpecialite.visible
        "
        fieldId="Specialite"
        :name="'Specialite'"
        :description="formData.field_ProfessionSpecialite.description"
        :tooltip="formData.field_ProfessionSpecialite.tooltip"
        :required="formData.field_ProfessionSpecialite.required"
        :enabled="formData.field_ProfessionSpecialite.enabled"
        :pattern="formData.field_ProfessionSpecialite.regexp"
        v-model="userData.labelSpeciality"
      ></input-fixed-field>
    </div>
    <profession-speciality
      v-else-if="
        formData.field_ProfessionSpecialite &&
          formData.field_ProfessionSpecialite.visible
      "
      fieldId="Field"
      :name="formData.field_ProfessionSpecialite.name"
      :description="formData.field_ProfessionSpecialite.description"
      :tooltip="formData.field_ProfessionSpecialite.tooltip"
      :required="formData.field_ProfessionSpecialite.required"
      :enabled="formData.field_ProfessionSpecialite.enabled"
      :professionId.sync="userData.idProfession"
      :specialityId.sync="userData.idSpeciality"
    ></profession-speciality>
  </div>
</template>

<script>
import Vue from "vue";
import { SharedService } from "@/Commons/services/SharedService";
import LabelField from "../fields/LabelField.vue";
import SelectField from "../fields/SelectField.vue";
import InputField from "../fields/InputField.vue";
import InputFixedField from "../fields/InputFixedField.vue";
import ProfessionSpeciality from "../fields/ProfessionSpeciality.vue";

export default Vue.extend({
  name: "cps-base-fields",

  components: {
    LabelField,
    SelectField,
    InputField,
    InputFixedField,
    ProfessionSpeciality
  },

  props: {
    formData: {
      type: Object,
      required: true
    },
    userData: {
      type: Object,
      required: true
    },
    isCps: {
      type: Boolean,
      default: true
    },
    creationMode: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      titles: [],
      hasProfessionSpecialite: false
    };
  },

  computed: {
    titleOptions() {
      return this.titles.map(t => ({ value: t.short, label: t.short }));
    }
  },

  methods: {
    async getTitles() {
      this.titles = await SharedService.getTitles();
    },
    getHasProfessionSpecialite() {
      this.hasProfessionSpecialite =
        this.userData.idProfession != null && this.userData.idProfession != -1;
    }
  },

  created() {
    this.getTitles();
    this.getHasProfessionSpecialite();
  },

  watch: {}
});
</script>

<style scoped>
.form-title {
  font-size: 25px;
  color: #2fa1ba;
  margin-bottom: 30px;
}
</style>
